import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CANCEL_ATA_SUCCESS,
  CREATE_SPARE_RECEIPT_ADVISE_SUCCESS,
  FETCH_ASSET_LIST_BY_STA,
  FETCH_OPEN_STA_SUCCESS,
  FETCH_SPARE_RECEIPT_ADVISE_SUCCESS,
  FETCH_SRA_NO_SUCCESS,
  GET_SPARE_RECEIPT_ADVISE_SUCCESS,
  SAVE_SPARE_RECEIPT_ADVISE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_SPARE_RECEIPT_ADVISE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SPARE_RECEIPT_ADVISE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_SPARE_RECEIPT_ADVISE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_SPARE_RECEIPT_ADVISE_SUCCESS,
    data,
  };
};

export const fetchAssetListByStaSuccess = ({data}) => {
  return {
    type: FETCH_ASSET_LIST_BY_STA,
    data,
  };
};

export const fetchSraNoSuccess = ({data}) => {
  return {
    type: FETCH_SRA_NO_SUCCESS,
    data,
  };
};

export const cancelAtaSuccess = ({data}) => {
  return {
    type: CANCEL_ATA_SUCCESS,
    data,
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {spareReceiptAdvise} = store.getState();
      const {query} = spareReceiptAdvise;
      const response = await axios.get(`/spare-receipt-advise?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {spareReceiptAdvise} = store.getState();
      const {query} = spareReceiptAdvise;
      const response = await axios.get(`/spare-receipt-advise/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }
        if(key === 'receivedBy' || key === 'spareParts') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/spare-receipt-advise`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/spare-receipt-advise');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if(!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }
        if(key === 'receivedBy') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        formData.append(key, payload[key]);
      });

      await axios.put(`/spare-receipt-advise/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      history.push('/spare-receipt-advise');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/spare-receipt-advise/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/spare-receipt-advise/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchSptListBySta = (sta) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    if(sta) {
      query = `sta=${sta}`;
    }
    try {
      const response = await axios.get(`/spare-transfer-advice/getSptBySta?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetListByStaSuccess(response));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchSraNo = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get('/spare-receipt-advise/getSraNo');
      dispatch(fetchSuccess());
      dispatch(fetchSraNoSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const cancelSta = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.post('/spare-receipt-advise/cancelSta', payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/spare-receipt-advise');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchOpenSta = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get('/spare-transfer-advice/open-sta');
      dispatch(fetchSuccess());
      dispatch(fetchOpenStaSuccess(response));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchOpenStaSuccess = ({data}) => {
  return {
    type: FETCH_OPEN_STA_SUCCESS,
    data,
  };
};
